import { CanActivateChildFn } from '@angular/router';
import { StateService } from '../other/state';
import { inject } from '@angular/core';
import { AynBroker_Role } from '../../helpers/systemRoles';

export const aynBrokerGuard: CanActivateChildFn = (_childRoute, _state) => {
  const stateService = inject(StateService);
  if (stateService.userRole() === AynBroker_Role) {
    return true;
  }
  return false;
};
